import { ArrowLeft } from "lucide-react";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const statusTabs = [
  { key: "CHARGED", label: "CHARGED" },
];

const VendorPaymentStatusTabs = () => {
  const location = useLocation();
  const paymentData = location.state?.data;
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("CHARGED"); // ✅ moved above

  if (!paymentData) {
    return <div className="font-satoshi text-center mt-10">No payment data available.</div>;
  }

  const getSortedPayments = (payments) => {
    if (!payments || !Array.isArray(payments)) return [];
    return [...payments].sort((a, b) => {
      const dateA = new Date(a.transactionDate);
      const dateB = new Date(b.transactionDate);

      if (isNaN(dateA.getTime()) && isNaN(dateB.getTime())) return 0;

      if (isNaN(dateA.getTime())) return 1;

      if (isNaN(dateB.getTime())) return -1;

      return dateB - dateA;

    });
  };

  const renderCard = (item, index) => (
    <div key={index} className="bg-white border rounded-lg p-4 shadow-sm mb-2">
      <div className="flex justify-between text-sm">
        <span className="text-gray-500">Vehicle No:</span>
        <span className="font-medium text-black">{item.vehicleNo}</span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-gray-500">Amount:</span>
        <span className="text-black font-semibold">₹ {item.paymentAmount?.toFixed(2) || "0.00"}</span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-gray-500">Date:</span>
         <span className="text-black">
          {item.transactionDate
            ? (() => {
                const date = new Date(item.transactionDate);
                const day = String(date.getDate()).padStart(2, "0");
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const year = date.getFullYear();
                let hours = date.getHours();
                const minutes = String(date.getMinutes()).padStart(2, "0");
                const seconds = String(date.getSeconds()).padStart(2, "0");
                const ampm = hours >= 12 ? "PM" : "AM";
                hours = hours % 12;
                hours = hours ? hours : 12;
                return `${day}/${month}/${year}`;
              })()
            : "—"}
        </span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-gray-500">Payment ID:</span>
        <span className="text-black">{item.paymentId || "—"}</span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-gray-500">Order ID:</span>
        <span className="text-black">{item.orderId || "—"}</span>
      </div>
    </div>
  );

   const sortedPayments = getSortedPayments(paymentData[activeTab]);

  return (
    <div className="font-satoshi bg-white h-[100vh] p-4">
      {/* Tab Buttons */}
      <button onClick={()=>{navigate('/crane-driver-home')}} className="absolute top-2 left-2 bg-blue-300 rounded-xl px-4 py-1"><ArrowLeft className=" h-4 w-4"/>{" "}</button>
      <div className="flex space-x-2 mb-4 mt-4">
        {statusTabs.map((tab) => (
          <button
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-4 py-2 rounded-md text-sm font-medium border ${
              activeTab === tab.key
                ? "bg-[#21a6e9] text-white border-[#21a6e9]"
                : "bg-white text-gray-700 border-gray-300"
            }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div>
        {sortedPayments.length > 0 ? (
          sortedPayments.map((item, index) => renderCard(item, index))
        ) : (
          <p className="text-center text-gray-500">
            No {activeTab} payments found.
          </p>
        )}
      </div>
    </div>
  );
};

export default VendorPaymentStatusTabs;
